import styled from 'styled-components';

const Label = styled.span`
  background-color: ${(props) => props.color || '#c7c7c7'};
  padding: 3px 7px;
  border-radius: 10px;
  color: white;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
`;

export default Label;
